import { Routes } from '../../../../navigation/config/routes'

export const PROPERTY_DETAILS_TAB = {
    details: 'details',
    community: 'community',
    vendorHours: 'vendor-hours',
    schoolsServed: 'schools-served',
    leaseTerms: 'lease-terms',
} as const

export type PropertyDetailsTabSlug = typeof PROPERTY_DETAILS_TAB[keyof typeof PROPERTY_DETAILS_TAB]

const TAB_SLUG_TO_INDEX: Record<string, number> = {
    [PROPERTY_DETAILS_TAB.details]: 0,
    [PROPERTY_DETAILS_TAB.community]: 1,
    'property-hours': 1,
    [PROPERTY_DETAILS_TAB.vendorHours]: 2,
    [PROPERTY_DETAILS_TAB.schoolsServed]: 3,
    [PROPERTY_DETAILS_TAB.leaseTerms]: 4,
}

const INDEX_TO_TAB_SLUG: Record<number, PropertyDetailsTabSlug> = {
    0: PROPERTY_DETAILS_TAB.details,
    1: PROPERTY_DETAILS_TAB.community,
    2: PROPERTY_DETAILS_TAB.vendorHours,
    3: PROPERTY_DETAILS_TAB.schoolsServed,
    4: PROPERTY_DETAILS_TAB.leaseTerms,
}

export function parsePropertyDetailsTabIndex(search: string): number {
    const tab = new URLSearchParams(search).get('tab')
    if (tab && tab in TAB_SLUG_TO_INDEX) {
        return TAB_SLUG_TO_INDEX[tab]
    }
    return 0
}

export function propertyDetailsTabSlugFromIndex(
    index: number,
): PropertyDetailsTabSlug {
    return INDEX_TO_TAB_SLUG[index] ?? PROPERTY_DETAILS_TAB.details
}

export function propertyDetailsPath(
    tab?: PropertyDetailsTabSlug | 'property-hours' | null,
): string {
    const base = Routes.shared.propertyDetails
    if (!tab || tab === PROPERTY_DETAILS_TAB.details) {
        return base
    }
    if (tab === 'property-hours') {
        return `${base}?tab=${PROPERTY_DETAILS_TAB.community}`
    }
    return `${base}?tab=${tab}`
}
